import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: ['recognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("type"),
            field: 'type',
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['recognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("pointsToObtain"),
            field: 'points',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['recognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("valueOfEachRecognition"),
            field: 'value',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['recognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("maxPercentageMoneyTrade"),
            field: 'percentage',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['recognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("maxValueForCashRedemption"),
            field: 'maxValue',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['recognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("pointsRedemption"),
            field: 'change',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['recognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("awardDelivery"),
            field: 'priceAwarding',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['recognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("dissemination"),
            field: 'diffusion',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['recognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("criticalIncidentLog"),
            field: 'annotations',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['recognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("exchangeObligation"),
            field: 'required',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionPlans],
        config: {
            headerName: getLocalizedString("planCode"),
            field: 'code',
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.recognitionPlans],
        config: {
            headerName: getLocalizedString("planName"),
            field: 'name',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.recognitionPlans],
        config: {
            headerName: getLocalizedString("planStatus"),
            field: 'statusString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionPlans],
        config: {
            headerName: getLocalizedString("specificWeight"),
            field: 'specificWeight',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.recognitionPlans],
        config: {
            headerName: getLocalizedString("valueOfEachPoint"),
            field: 'pointValue',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.recognitionPlans],
        config: {
            headerName: getLocalizedString("planMaximumBudget"),
            field: 'maxBudget',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            headerName: getLocalizedString("planCode"),
            field: 'Codigo de plan',
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            headerName: getLocalizedString("planName"),
            field: 'Nombre del Plan',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            field: 'Estado del plan',
            headerName: getLocalizedString("planStatus"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: 'Código de empleado',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: 'Apellido y nombres',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            field: 'Estado empleado en el plan',
            headerName: getLocalizedString("employeeStatusInPlan"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            field: 'Fecha de asignación al plan',
            headerName: getLocalizedString("assignmentDateToPlan"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            headerName: getLocalizedString("fType"),
            field: 'Tipo de funcionario',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            headerName: getLocalizedString("position"),
            field: 'Cargo',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            headerName: getLocalizedString("management"),
            field: 'Gerencia',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: 'Centro de costo de gestión',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            headerName: getLocalizedString("contractType"),
            field: 'Tipo de contrato',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: 'Fecha de contratación',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: 'Lugar de trabajo',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['collaboratorsInPlans'],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: 'Obra o Faena',
            filter: "agSetColumnFilter",
        }
    },
    // benefitRecognitionPlansDetail
    {
        pages: ['benefitRecognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: 'Código de empleado',
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['benefitRecognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: 'Apellido y Nombres',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['benefitRecognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("state"),
            field: 'Estado',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['benefitRecognitionPlansDetail'],
        config: {
            field: 'Fecha de solicitud',
            headerName: getLocalizedString("requestDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ['benefitRecognitionPlansDetail'],
        config: {
            field: 'Puntos canjeados',
            headerName: getLocalizedString("redeemedPoints"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['benefitRecognitionPlansDetail'],
        config: {
            field: 'Tipo de canje',
            headerName: getLocalizedString("redemptionType"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['benefitRecognitionPlansDetail'],
        config: {
            field: 'Beneficio',
            headerName: getLocalizedString("benefit"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['benefitRecognitionPlansDetail'],
        config: {
            headerName: getLocalizedString("employeesProcessAmount"),
            field: 'Cantidad',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['benefitRecognitionPlansDetail'],
        config: {
            field: 'Valor del beneficio',
            headerName: getLocalizedString("benefitValue"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },

]